import { render } from "./PortfolioFullPlate.vue?vue&type=template&id=833f0c56&scoped=true"
import script from "./PortfolioFullPlate.vue?vue&type=script&lang=js"
export * from "./PortfolioFullPlate.vue?vue&type=script&lang=js"

import "./PortfolioFullPlate.vue?vue&type=style&index=0&id=833f0c56&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Kyler\\OneDrive\\Website\\website2022\\development\\kylerherrera-2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833f0c56"]])

export default __exports__